import EventDispatcher = createjs.EventDispatcher;
import LoadQueue = createjs.LoadQueue;
import AbstractLoader = createjs.AbstractLoader;
import LoadItem = createjs.LoadItem;
import Event = createjs.Event;
import ErrorEvent = createjs.ErrorEvent;
import { LoadingItem } from "./LoadingItem";

//TODO HTML-2231 - this solution is barely working, we need to make this solid

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BulkLoader");

export class BulkLoader extends EventDispatcher {
    public static loadedList: Map<string, AbstractLoader> = new Map<string, AbstractLoader>();
    private loadingList: Map<string, LoadingItem> = new Map<string, LoadingItem>();

    public static COMPLETE: string = "complete";
    public static PROGRESS: string = "progress";
    public static ERROR: string = "error";
    public static FILE_LOAD: string = "fileload";
    public static FILE_PROGRESS: string = "fileprogress";

    public id: string;
    public loadQueue: LoadQueue = new LoadQueue();

    //TODO check if we really need this
    private _numConnections = 0;

    constructor(id: string) {
        super();
        this.id = id;

        // Set a higher number to load multiple items at once
        this.loadQueue.setMaxConnections(50);
        this.loadQueue.maintainScriptOrder = true;

        // FIXME: bigfarm-createjs-assets needs to know the reference to the JSON file.
        if (id === "assetLoader") {
            (<any>window).AssetLoader = this.loadQueue;
        }

        this.loadQueue.on(BulkLoader.COMPLETE, (e) => {
            setTimeout(() => { this.dispatchEvent(new Event(Event.COMPLETE, true)); }, 1);
        }, this);
        this.loadQueue.on(BulkLoader.ERROR, (e) => {
            setTimeout(() => { this.dispatchEvent(e); }, 1);
        }, this);
    }


    public start(withConnections: number = -1 ): void {
        //TODO check if we really need this at all since stuff will be loaded at hoc


        if (withConnections  > 0) {
            this._numConnections = withConnections;
        }
        // if(_connections){
        //     _loadNext();
        //     return;
        // }
        // _startTime = getTimer();
        //
        // _connections = {};
        // _loadNext();
        // _isRunning = true;
        // _lastBytesCheck = 0;
        // _lastSpeedCheck = getTimer();
        // _isPaused = false;
    }

    public add(assetUrl: string, properties: any): AbstractLoader {
        properties.src = assetUrl;
        let loader;

        if (!this.isLoaded(assetUrl)) {
            loader = <any>this.loadQueue.loadFile(properties);
        } else {
            loader = BulkLoader.loadedList.get(assetUrl);

            if (loader.loaded) {

                let event = new createjs.LoaderEvent(Event.COMPLETE, false, true);
                event.result = loader.getResult();
                event.url = assetUrl;
                event.rawResult = loader.getResult(assetUrl, true);

                setTimeout(() => { loader.dispatchEvent(event); }, 1);
            }

        }

        return loader;
    }

    public addAssetBundle(assetUrl: string, properties: any): LoadingItem {

        if (this.loadingList.has(assetUrl)) {
            return this.loadingList.get(assetUrl);
        }

        const url_js = `${assetUrl}.js`;
        const url_json = `${assetUrl}.json`;
        const script_appendix = "Script";

        let dispatcher = new LoadingItem();

        this.loadingList.set(assetUrl, dispatcher);

        let loadedFiles = 0;
        let loadedCallback = (target: string, e) => {

            BulkLoader.loadedList.set(`${assetUrl}.${e.currentTarget._item.ext}`, e.currentTarget);

            loadedFiles++;
            if (loadedFiles === 2) {
                //
                // Need to delay "COMPLETE" a bit, to have the `getResult`
                // available on LoadQueue instance.
                //
                // This happens due CreateJS triggering events in FILO order (first in last out)
                //

                let event = new createjs.LoaderEvent(Event.COMPLETE, false, true);
                event.url = assetUrl;
                logger.debug("Finished loading: " + assetUrl);
                this.loadingList.delete(assetUrl);
                let resultKey = target.replace(script_appendix, "");
                let checker = window.setInterval(() => {
                    // we have to explicitly make sure loadQueue.getResult is ready
                    if ((window as any).AssetLoader.getResult(resultKey)) {
                        window.clearInterval(checker);
                        dispatcher.dispatchEvent(event);
                    }
                }, 2);
            }
        };

        if (!this.isLoaded(url_js)) {
            let javascriptLoader = this.add(url_js, {
                id: properties.id + script_appendix,
                type: createjs.AbstractLoader.JAVASCRIPT,
                priority: properties.priority || 1
            });
            javascriptLoader.addEventListener(Event.COMPLETE, loadedCallback.bind(this, properties.id + script_appendix));
            javascriptLoader.addEventListener(Event.COMPLETE, (e) => {
                javascriptLoader.removeAllEventListeners();
            });
            javascriptLoader.addEventListener("error", (e) => {
                setTimeout(() => {
                    dispatcher.dispatchEvent(e);
                    javascriptLoader.removeAllEventListeners();
                }, 1);
            });

            //TODO HTML-2105 remove this as soon as we got an identicator for spritesheets that dont contain a js file
            javascriptLoader.addEventListener("error", loadedCallback.bind(this, properties.id + script_appendix));
        } else {
            loadedFiles++;
        }

        if (!this.isLoaded(url_json)) {
            let spritesheetLoader = this.add(url_json, {
                id: properties.id,
                type: createjs.AbstractLoader.SPRITESHEET,
                priority: properties.priority || 1
            });
            spritesheetLoader.addEventListener(Event.COMPLETE, loadedCallback.bind(this, properties.id));
            spritesheetLoader.addEventListener(Event.COMPLETE, (e) => {
                spritesheetLoader.removeAllEventListeners();
            });
            spritesheetLoader.addEventListener("error", (e) => {
                setTimeout(() => {
                    dispatcher.dispatchEvent(e);
                    spritesheetLoader.removeAllEventListeners();
                }, 1);
            });
        } else {
            loadedFiles++;
        }

        if (this.isLoaded(url_js) && this.isLoaded(url_json)) {
            dispatcher._isLoaded = true;
        }

        return dispatcher;
    }

    get isRunning(): boolean {
        return !this.loadQueue.loaded;
    }


    public removeAll(): void {
        this.loadQueue.cancel();
        this.loadQueue.removeAll();
        this.loadQueue.close();
    }

    public isLoaded(url: string): boolean {
        return BulkLoader.loadedList.has(url) // single file
            || (BulkLoader.loadedList.has(url + ".js") && BulkLoader.loadedList.has(url + ".json") && BulkLoader.loadedList.get(url + ".json").loaded  ); // assetbundle
    }

    public get isFinished(): boolean {
        return (this.loadQueue as any)._loadQueue.length === 0;
    }
}
